export const composeClassicEmail = (firstName = "", lastName = "", defaultMessage) => {
  const emailContent = `${defaultMessage}
${firstName} ${lastName}`;
  return emailContent;
};
